/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { AddressRequest } from './address-request';

/**
 * 
 * @export
 * @interface RegisterRequest
 */
export interface RegisterRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'fullName': string;
    /**
     * 
     * @type {AddressRequest}
     * @memberof RegisterRequest
     */
    'address'?: AddressRequest;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'gender'?: RegisterRequestGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'birthDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof RegisterRequest
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof RegisterRequest
     */
    'weight'?: number;
    /**
     * 
     * @type {number}
     * @memberof RegisterRequest
     */
    'targetWeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'otpVerificationCode': string;
    /**
     * 
     * @type {Set<string>}
     * @memberof RegisterRequest
     */
    'allergens'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof RegisterRequest
     */
    'medicalConditions'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof RegisterRequest
     */
    'dislikes'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'deliveryPhoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'dietGoal'?: RegisterRequestDietGoalEnum;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'dietType'?: RegisterRequestDietTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'activityLevel'?: RegisterRequestActivityLevelEnum;
}

export const RegisterRequestGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE'
} as const;

export type RegisterRequestGenderEnum = typeof RegisterRequestGenderEnum[keyof typeof RegisterRequestGenderEnum];
export const RegisterRequestDietGoalEnum = {
    LoseWeight: 'LOSE_WEIGHT',
    Maintenance: 'MAINTENANCE',
    GainWeight: 'GAIN_WEIGHT',
    IncreaseMuscles: 'INCREASE_MUSCLES',
    EatHealthy: 'EAT_HEALTHY'
} as const;

export type RegisterRequestDietGoalEnum = typeof RegisterRequestDietGoalEnum[keyof typeof RegisterRequestDietGoalEnum];
export const RegisterRequestDietTypeEnum = {
    LowCarb: 'LOW_CARB',
    Balanced: 'BALANCED',
    Vegan: 'VEGAN',
    HighProtein: 'HIGH_PROTEIN',
    Keto: 'KETO',
    GlutenFree: 'GLUTEN_FREE'
} as const;

export type RegisterRequestDietTypeEnum = typeof RegisterRequestDietTypeEnum[keyof typeof RegisterRequestDietTypeEnum];
export const RegisterRequestActivityLevelEnum = {
    Sedentary: 'SEDENTARY',
    LightlyActive: 'LIGHTLY_ACTIVE',
    ModeratelyActive: 'MODERATELY_ACTIVE',
    VeryActive: 'VERY_ACTIVE',
    ExtremelyActive: 'EXTREMELY_ACTIVE'
} as const;

export type RegisterRequestActivityLevelEnum = typeof RegisterRequestActivityLevelEnum[keyof typeof RegisterRequestActivityLevelEnum];


